export default (state = {}, action) => {
  return state
}
